module.exports = "<svg id=\"5c6cf975-5bc9-4ebe-9921-820cd2073290\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><defs></defs><title>DownArrow</title><path class=\"8753f58e-c5bc-4195-8c76-3bb996c15521\" d=\"M45.27,14,28.09,27.67v-.1L25.17,30,22.26,27.6v.07L5.15,13.94A3.1,3.1,0,0,0,1,14.4,2.93,2.93,0,0,0,1.5,18.5L23.39,36a2.67,2.67,0,0,0,1.82.63h0A4.31,4.31,0,0,0,27,36l21.88-17.5a2.94,2.94,0,0,0,.45-4.11A3,3,0,0,0,45.27,14Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/DownArrow.svg
// module id = +0Tf
// module chunks = 1